import { render, staticRenderFns } from "./BatchRemittanceList.vue?vue&type=template&id=633e0ca8&"
import script from "./BatchRemittanceList.vue?vue&type=script&lang=js&"
export * from "./BatchRemittanceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports